import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  OmniAuthAccountResponseSchema,
  OmniAuthAccountSchema,
  OmniAuthQuerySchema,
} from '../../shared/schemas/Accounts.js';

export const getOmniAuthAccounts = defaultClient.query({
  url: 'omni-connector-service/auth/accounts' as const,
  method: 'GET',
  responseSchema: OmniAuthAccountResponseSchema,
  querySchema: OmniAuthQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getOmniAuthMicrosoftAdvertisingAccounts = defaultClient.query({
  url: 'omni-connector-service/auth/microsoft_advertising/accounts' as const,
  method: 'GET',
  responseSchema: OmniAuthAccountResponseSchema,
  querySchema: OmniAuthQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getOmniAuthOAuth1Accounts = defaultClient.query({
  url: 'omni-connector-service/auth/accounts/oauth1' as const,
  method: 'GET',
  responseSchema: OmniAuthAccountResponseSchema,
  querySchema: OmniAuthQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getOmniAuthAmazonAccounts = defaultClient.query({
  url: 'omni-connector-service/auth/amazon/accounts' as const,
  method: 'GET',
  responseSchema: OmniAuthAccountResponseSchema,
  querySchema: OmniAuthQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getOmniAuthTradeDeskAccounts = defaultClient.query({
  url: 'omni-connector-service/auth/tradedesk/accounts' as const,
  method: 'GET',
  responseSchema: OmniAuthAccountResponseSchema,
  querySchema: OmniAuthQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export type AccountType = z.infer<typeof OmniAuthAccountSchema>;
